import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import ClientSSRInterface from '../../interfaces/client/SSR'
import ReduxStoreInterface from '../../interfaces/client/ReduxStore'
import NotificationInterface from '../../interfaces/client/Notification'

import { openSpecialSSRModal } from '../../actions/modals'
import { addSpecialSSRModalData } from '../../actions/ssrs'
import { addPassengerSSR } from '../../actions/passengers'
import { removeNotification } from '../../actions/notifications'

import parseFlightId from '../../utils/parseFlightId'
import generateUniqueId from '../../utils/generateUniqueId'
import { getFieldNotification } from '../../utils/notifications'
import { minDifferenceTwoYearsBetweenDates } from '../../utils/validation'
import getWarningNotifications from '../../utils/notifications/getWarningNotifications'
import parentDateOfBirthValidation from '../../utils/forms/parentDateOfBirthValidation'

import NewBookingFormRow from '../../components/NewBookingFormRow'

interface NewBookingFormRowPropsInterface {
  passengerId: string
  rowId: number
  travelClassType: string
  isTOFlight: boolean
  departureFlightId: string
}

export const mapStateToProps = (
  state: ReduxStoreInterface,
  props: NewBookingFormRowPropsInterface
) => {
  const passengerId =
    state.passengersBooked.byId[String(props.passengerId)] || props.passengerId
  const departureDate = parseFlightId(props.departureFlightId).date
  const bookedPassenger = state.passengers.byId[passengerId]
  const pnr = bookedPassenger
    ? bookedPassenger.transaviaBookingNumber
    : undefined

  const uploadedPassenger = state.uploadedPassengers.byId[props.passengerId]

  const specialSSRNames = state.ssrs.allIds
    .map((ssr: string) => state.ssrs.byId[ssr])
    .filter((ssr: ClientSSRInterface) => ssr.isSpecialSSR)
    .map((ssr: ClientSSRInterface) => ssr.id)
  const passengerErrors =
    state.notifications.passengerIdsToNotificationIds[props.passengerId]
  const hasErrors = Boolean(passengerErrors)

  const errors: NotificationInterface[] = hasErrors
    ? getWarningNotifications(
        passengerErrors.map(
          (notificaitonKey: string) => state.notifications.byId[notificaitonKey]
        )
      )
    : []

  const dateOfBirthError = getFieldNotification(errors, 'DateOfBirth')
  const firstNameError = getFieldNotification(errors, 'FirstName')
  const lastNameError = getFieldNotification(errors, 'LastName')
  const thirdPartyBookingNumberError = getFieldNotification(
    errors,
    'thirdPartyBookingNumber'
  )

  return {
    rowId: props.rowId,
    passengerId: props.passengerId,
    travelClass: props.travelClassType,
    departureFlightId: props.departureFlightId,
    specialSSRNames,
    showTravelClass: props.isTOFlight,
    showLuggage: !props.isTOFlight,
    showSSRButton: !props.isTOFlight,
    isDisabled: state.requests.isFetchingPassengers.includes(props.passengerId),
    readonly: bookedPassenger ? 'readonly' : undefined,
    pnr,
    firstNameError,
    lastNameError,
    dateOfBirthError,
    thirdPartyBookingNumberError,
    uploadedPassenger,
    dateValidator: minDifferenceTwoYearsBetweenDates(departureDate),
  }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  addSSR: (passengerId: string, ssrId: string, specialSSRNames: string[]) => {
    const passengerSSRId = `${ssrId}-${generateUniqueId()}`

    if (specialSSRNames.includes(ssrId)) {
      dispatch(addSpecialSSRModalData(passengerId, ssrId))
      dispatch(openSpecialSSRModal())

      return
    }

    const addPassengerSSROptions = {
      isConfirmed: false,
      isAbleToDelete: true,
    }
    dispatch(
      addPassengerSSR(
        passengerId,
        passengerSSRId,
        ssrId,
        addPassengerSSROptions
      )
    )
  },
  removeNotification: (notification: NotificationInterface) => {
    dispatch(removeNotification(notification.id))
  },
  validateDateOfBirth: (
    targetElement: HTMLInputElement,
    passengerId: string,
    validator: Function,
    dateOfBirthError?: NotificationInterface
  ) =>
    parentDateOfBirthValidation(
      targetElement,
      passengerId,
      validator,
      dispatch,
      dateOfBirthError
    ),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewBookingFormRow)
